import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { NotificationService } from '../../core/notification.service';
import { UsersService } from '../../core/users.service';
import { ApplicationFeedback } from '../../shared/interfaces/api-response';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent {
  registerForm = new FormGroup({
    username: new FormControl<string>("", { nonNullable: true }),
    password: new FormControl<string>("", { nonNullable: true }),
    email: new FormControl<string>("", { nonNullable: true })
  })
  constructor(private usersService: UsersService, private notificationService: NotificationService) { }

  async onRegisterClicked() {
    await this.usersService.registerUser(
      this.registerForm.getRawValue().username
      , this.registerForm.getRawValue().password
      , this.registerForm.getRawValue().email).then((response: ApplicationFeedback) => {
        // if registration successful, clear out form
        if (response.success) {
          this.notificationService.displaySuccess('Created ' + this.registerForm.getRawValue().username)
          this.registerForm.setValue({ username: '', password: '', email: '' })
        }
        else {
          this.notificationService.displayError(String(response.message));
        }
      })
  }
}
